import { useMutation } from '@tanstack/react-query';
import type { AcceptInvitationInput } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';

interface AcceptInvitationResponse {
  success: boolean;
  data: { userId: number; tenantId: number; roleCode: string };
}

export function useAcceptInvitation(token: string) {
  return useMutation({
    mutationFn: async (input: AcceptInvitationInput) => {
      const response = await apiClient.post<AcceptInvitationResponse>(
        `/users/invitations/${token}/accept`,
        input,
      );
      return response.data.data;
    },
  });
}
